export interface RemoveClaManager {
  projectId: string;
  companyId: string;
  lfUsername: string;
}
